/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-multi-assign */

import { attatchScript } from 'globalUtils';

/**
 * Asyncronously obtain a package from given CDN src, and attatch it to a given
 * dom node.
 *
 * Resolve once package has loaded.
 * Reject on package load error.
 *
 * @category Global Module Utils
 * @module loadFromCDN
 * @param {string} src source url of package
 * @param {array} attrs attributes added to script tag
 * @param {Node} parentNode - node to attatch script tag to
 */
export const loadFromCDN = (src, attrs, parentNode) => {
	if (!window.requiredCDNScripts) {
		window.requiredCDNScripts = [];
	}
	if (window.requiredCDNScripts.includes(src)) {
		return new Promise((resolve) => resolve());
	}
	window.requiredCDNScripts.push(src);

	return attatchScript(src, attrs, parentNode);
};

/**
 * Define packages to load asyncronously and what should happen upon
 * their loading. Each one can then be called up directly as a property on CDNPackages.
 *
 * @category Global Module Utils
 * @type {Object}
 * @example
 * await CDNPackages.jsPDF
 * const jsPDF = window.jsPDF
 */
export const CDNPackages = {
	jsPDF: async () => {
		if (!window.jspdf) {
			await loadFromCDN('https://unpkg.com/jspdf@2.2.0/dist/jspdf.umd.min.js');
			window.jsPDF = jspdf.jsPDF;
			await loadFromCDN(
				'https://unpkg.com/jspdf-autotable@3.5.13/dist/jspdf.plugin.autotable.js',
			);
		}
	},
};
